import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchServiceDetail = async (slug) => {
  try {
    // Retrieve lang value from localStorage
    const lang = localStorage.getItem("lang") || "ru"; // Default to "ru" if not found

    const response = await axios.get(`${BASE_URL}/api/service/detail/${slug}`, {
      params: { lang }, // Append lang as a query parameter
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching service detail:", error);
    throw error;
  }
};
